import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SoftwareSection.module.css';
import useScrollAnimation from '../../hooks/useScrollAnimation';

const featuresConfig = [
    {
        id: 'feature-tracks',
        imgSrc: '/images/gg-webapp-field-tracks-speed.png',
        altKey: 'software.features.feature-tracks.alt'
    },
    {
        id: 'feature-yield-maps',
        imgSrc: '/images/gg-webapp-yield-map-triticale.png',
        altKey: 'software.features.feature-yield-maps.alt'
    },
    {
        id: 'feature-productivity-zones',
        imgSrc: '/images/gg-webapp-prescription-map-settings.png',
        altKey: 'software.features.feature-productivity-zones.alt'
    }
];

const FeatureItem = ({ id, imgSrc, altKey }) => {
    const { t } = useTranslation();
    const itemRef = useScrollAnimation({ once: true });
    const altText = t(altKey, { defaultValue: id });
    const webpSrc = imgSrc.replace(/\.png$/, '.webp');
    return (
        <div className={`${styles.softwareFeatureItem} animate-on-scroll`} id={id} ref={itemRef}>
            <div className={styles.featureImageContainer}>
                <picture>
                    <source srcSet={webpSrc} type="image/webp" />
                    <img src={imgSrc} alt={altText} loading="lazy" />
                </picture>
            </div>
            <h3>{t(`software.features.${id}.title`)}</h3>
            <p>{t(`software.features.${id}.description`)}</p>
        </div>
    );
};

const SoftwareSection = () => {
    const { t } = useTranslation();
    const sectionRef = useScrollAnimation({ once: true });

    return (
        <section 
            id="software-interactive" 
            className={`${styles.softwareInteractive} animate-on-scroll`}
            ref={sectionRef}
        >
            <div className={`container ${styles.customContainer}`}>
                <h2 className={`section-title ${styles.sectionTitle}`}>{t('software.title')}</h2>
                <div className={styles.softwareInteractiveLayout}>
                    <div className={styles.softwareStickyLeft}>
                        <div className={styles.stickyImageWrapper}>
                            <picture>
                                <source srcSet="/images/apps.webp" type="image/webp" />
                                <img src="/images/apps.png" alt={t('software.mainImageAlt', {defaultValue: 'Green Growth System Overview'})} loading="lazy" />
                            </picture>
                        </div>
                    </div>
                    <div className={styles.softwareScrollableRight}>
                        {featuresConfig.map(feature => (
                            <FeatureItem key={feature.id} {...feature} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SoftwareSection;
